import { render, staticRenderFns } from "./chattitle.vue?vue&type=template&id=b9f81e04&scoped=true&"
import script from "./chattitle.vue?vue&type=script&lang=js&"
export * from "./chattitle.vue?vue&type=script&lang=js&"
import style0 from "./chattitle.vue?vue&type=style&index=0&id=b9f81e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f81e04",
  null
  
)

export default component.exports